import { useLazyQuery } from "@apollo/client";
import { useState, useCallback, useEffect } from "react";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import { GET_ROLE_DETAIL } from "../../../graphql/position-gql";
import { IOrg, ICategory } from "../../../types/org";
import { IPosition } from "../../../types/position";
import CollapsablePanel from "../../common/collapsable-panel/collapsable-panel";
import { AddIcon, DeleteIcon } from "../../common/icons";
import RoleInformation from "./role-information/role-information";
import AssignedIndividual from "./assigned-individual/assigned-individual";
import AssignIndividualModal from "../../position/position-detail/assign-individual/assign-individual";
import useToggle from "../../../hook/useToggle";
import AuthWrapper from "../../common/auth-wrapper";
import { UserRoleType } from "../../../types/constants";
import RoleInformationGrp from "./role-information/role-information-grp";

type RoleDetailProps = {
    role: IPosition;
    updateSelectedRole?:(updatedRole:IPosition)=>void
    //onUpdatePositionName:(name:string)=>void
}

const RoleDetailsGrp = (props: RoleDetailProps) => {
    const {role,updateSelectedRole} = props
    // const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    // const { isOpen : isAssignOpen, toggle : assignToggle } = useToggle()
    const [roleDetail,setRoleDetail] = useState<IPosition>()
    // const toggleDropdownOpen = useCallback(() => {setDropdownOpen(!dropdownOpen)}, [dropdownOpen])
    // const [expirable,setExpirable] = useState<boolean>(false);
    const [getRoleDetail,{ data:roleDetailData }]= useLazyQuery(GET_ROLE_DETAIL);

    useEffect(()=>{
        getRoleDetail({variables:{roleId:role.positionId},fetchPolicy: "network-only"});
        
    },[role,getRoleDetail])

    useEffect(()=>{
        
        if(roleDetailData?.role)
            setRoleDetail(roleDetailData?.role)
    },[roleDetailData])
    
       
    return (
        <div>
            {roleDetail &&<>
            <CollapsablePanel headTitle="Role Information" initCollapse={false} helpUrl="">
                <RoleInformationGrp  role={roleDetail} updateSelectedRole={updateSelectedRole}  />
            </CollapsablePanel>
            </>}
        </div>
    )
}

export default RoleDetailsGrp;
